import FlexItemGrid from '@components/display/FlexItemGrid'
import styles from 'styles/AddFormTileGrid.module.css'

const TileGrid = ({ children }) => {
    return (
        <FlexItemGrid styles={styles}>
            { children }
        </FlexItemGrid>
    )
}

export default TileGrid